var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationsOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 0C4.19391 0 3 1.19391 3 2.66667H0.666667C0.298477 2.66667 0 2.96514 0 3.33333V7.33333C0 7.70152 0.298477 8 0.666667 8H2C2.73638 8 3.33333 8.59695 3.33333 9.33333C3.33333 10.0697 2.73638 10.6667 2 10.6667H0.666667C0.298477 10.6667 0 10.9651 0 11.3333V14C0 14.3682 0.298477 14.6667 0.666667 14.6667H10.6667C11.0349 14.6667 11.3333 14.3682 11.3333 14V12H12C13.4728 12 14.6667 10.8061 14.6667 9.33333C14.6667 7.86057 13.4728 6.66667 12 6.66667H11.3333V3.33333C11.3333 2.96514 11.0349 2.66667 10.6667 2.66667H8.33333C8.33333 1.19391 7.13943 0 5.66667 0Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsOn);
export default __webpack_public_path__ + "static/media/integrations-on.3e1f6c4a06614a5c8732a00d1512c481.svg";
export { ForwardRef as ReactComponent };